var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row"},[_c('button',{staticClass:"btn",class:_vm.field.cssClass,on:{"click":function($event){return _vm.run()}}},[_vm._v(" "+_vm._s(_vm.field.displayLabel)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }